export const FOLDER_ITEM_TYPE_FOLDER = 'folder';
export const FOLDER_ITEM_TYPE_FILE = 'file';